/**
 * Unwraps an element from either a DOM element or Vue component instance.
 * If the input is a Vue component instance, returns its $el property.
 * Otherwise, returns the element as is.
 *
 * @param el - The element or Vue instance to unwrap
 * @returns The unwrapped DOM element or undefined if input is null/undefined
 *
 * @__NO_SIDE_EFFECTS__
 */
export function unwrapElement(el) {
    if (!el) {
        return undefined;
    }
    return (el.$el ?? el);
}
//# sourceMappingURL=unwrapElement.js.map